var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media"},[_c('EmbeddedVideo',{staticClass:"player",attrs:{"video":_vm.round.media,"pillarboxed":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }